import "./ESignApprovalComponent.scss";
import {CommonService} from "../../services";
import LoaderComponent from "../loader/LoaderComponent";

interface ESignApprovalComponentProps {
    isLoading?: boolean;
    canSign?: boolean;
    isSigned: boolean;
    isSigning?: boolean;
    onSign?: () => void;
    signedAt?: string;
    signature_url?: string;
}

const ESignApprovalComponent = (props: ESignApprovalComponentProps) => {

    const {isSigned, isLoading, signedAt, signature_url} = props;

    // const handleOnSign = useCallback(() => {
    //     if (onSign) {
    //         onSign();
    //     }
    // }, [onSign]);

    return (
        <div className={'e-sign-approval-component'}>
            <div className="e-sign-image-action-wrapper">
                <div className={`e-sign-image-container ${isSigned ? "signed" : "unsigned"}`}>
                    <img src={signature_url} alt="Signature"/>
                </div>
                {/*{*/}
                {/*    !isSigned && <div className="e-sign-action-container">*/}
                {/*        <ButtonComponent onClick={handleOnSign} isLoading={isSigning} disabled={isSigning || !canSign}>*/}
                {/*            Sign*/}
                {/*        </ButtonComponent>*/}
                {/*    </div>*/}
                {/*}*/}
            </div>
            {signedAt && <div className="e-sign-time-stamp">
                Electronically signed on : <> {CommonService.transformTimeStamp(signedAt)} </>
            </div>}
            {
                isLoading && <div className={'e-sign-loading'}>
                    <LoaderComponent size={"sm"} type={"spinner"}/>
                </div>
            }
        </div>
    );

};

export default ESignApprovalComponent;
